import React from 'react';
import './Cards.css';

function CardItem({ src, title, price, description, onClick }) {
  return (
    <li className='cards__item'>
      <div className='cards__item__link' onClick={onClick}>
        <figure className='cards__item__pic-wrap'>
          <img
            className='cards__item__img'
            alt={title}
            src={src}
          />
        </figure>
      </div>
      <div className='cards__item__details'>
        <div className='cards__item__title'>{title}</div>
        <div className='cards__item__price'>{price}</div>
        <button className='cards__item__button'>Purchase</button>
      </div>
    </li>
  );
}

export default CardItem;